<template>
  <div class="work-with-us-page">
    <WorkWithUsHero :title="adminHeading" />
    <AboutMarquee :items="marqueeItems" />
    <WorkWithUsIntro />
    <WorkWithUsPhotos />
    <WorkWithUsCards />
    <WorkWithUsWholesale />
    <WorkWithUsContact />
  </div>
</template>

<script>
import "./work_with_us.css";

import WorkWithUsHero from "~/components/work-with-us/WorkWithUsHero.vue";
import AboutMarquee from "~/components/about/AboutMarquee.vue";
import WorkWithUsIntro from "~/components/work-with-us/WorkWithUsIntro.vue";
import WorkWithUsPhotos from "~/components/work-with-us/WorkWithUsPhotos.vue";
import WorkWithUsCards from "~/components/work-with-us/WorkWithUsCards.vue";
import WorkWithUsWholesale from "~/components/work-with-us/WorkWithUsWholesale.vue";
import WorkWithUsContact from "~/components/work-with-us/WorkWithUsContact.vue";
import { useStaticPageSeo } from "~/core/composables/useStaticPageSeo";

const MARQUEE_ITEMS = [
  "Influencers Welcome",
  "Content Creators",
  "Fashion Enthusiasts",
  "Designer Eyewear",
  "Join the Family",
  "100% Authentic Frames",
  "Let's Collaborate",
  "Hooligans Eyewear",
];

export default {
  name: "WorkWithUs",
  setup() {
    return useStaticPageSeo({
      title: "Work With Hooligans Eyewear | Partnerships & Wholesale",
      heading: "Work With Us",
      description:
        "Explore wholesale, creator, stylist, and brand partnership opportunities with Hooligans Eyewear and our authentic designer eyewear collection.",
    });
  },
  components: {
    WorkWithUsHero,
    AboutMarquee,
    WorkWithUsIntro,
    WorkWithUsPhotos,
    WorkWithUsCards,
    WorkWithUsWholesale,
    WorkWithUsContact,
  },
  data() {
    return {
      marqueeItems: MARQUEE_ITEMS,
    };
  },
  mounted() {
    this._reduceMotion =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    this._setupRevealObserver();
  },
  beforeUnmount() {
    if (this._revealObserver) {
      this._revealObserver.disconnect();
      this._revealObserver = null;
    }
  },
  methods: {
    _setupRevealObserver() {
      const els = this.$el.querySelectorAll(".reveal");
      if (!els.length) return;

      if (this._reduceMotion || typeof IntersectionObserver === "undefined") {
        els.forEach((el) => el.classList.add("visible"));
        return;
      }

      this._revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              this._revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      els.forEach((el) => this._revealObserver.observe(el));
    },
  },
};
</script>
